import { apiFetch } from '../utils/apiFetch';  // Add at the top
export async function fetchHighSchoolMentors() {
  try {
    const apiUrl = process.env.REACT_APP_API_URL;

    const response = await apiFetch(`${apiUrl}/high_school_mentors`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) throw new Error('Failed to fetch high school mentors');

    const data = await response.json();

    return data.map(mentor => ({
      ...mentor,
      name: decodeURIComponent(mentor.name),
    }));
  } catch (error) {
    console.error('Error fetching high school mentors:', error);
    throw error;
  }
}
